<db-dialog-wrapper [dialog]="this" [width]="'676px'" [height]="'558px'">
  <div class="db-inactive-website-troubleshoot">
    <div class="db-inactive-website-troubleshoot-wrap" dbCustomScrollbar>
      <div class="db-inactive-website-troubleshoot-header">
        <h3>{{'text_inactiveWebsiteTitle' | dbText}}</h3>
        <p [innerHTML]="'text_inactiveWebsiteDesc' | dbText"></p>
      </div>
<!--      <div class="db-inactive-website-troubleshoot-body">-->
<!--        <div class="db-video_container" [ngClass]="{'db-hide-background': hideBackground}">-->
<!--          <video width="616" height="349" playsinline muted loop autoplay >-->
<!--            <source src="../../assets/images/how-to-connect.mp4" type="video/mp4">-->
<!--            Your browser does not support the video tag.-->
<!--          </video>-->

<!--          <div class="db-action-manager__toggle">-->
<!--            <svg class="indicator" width="24px" height="24px" viewBox="3 -3 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">-->
<!--              <circle fill="none" stroke="#FFFFFF" stroke-width="2" cx="13" cy="7" r="9" class="border"></circle>-->
<!--              <circle fill="#fff" r="4" cx="13" cy="13" class="spinner"  attr.stroke-dasharray="{{radius - (radius * (1-((      radiusForWatched     )/100)))}}, {{radius}}"></circle>-->
<!--            </svg>-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="db-inactive-website-troubleshoot-body">
        <div class="db-inactive-website-troubleshoot__content" >
          <div class="db-inactive-website-troubleshoot-connect">
            <div>
              <h2>First, connect your website to the 10Web dashboard<br/>by installing the 10Web Manager plugin</h2>
              <h1>Download<a href="{{managerLink}}" download (click)="downloadManagerPluginEvent()"  class="db-custom-link"> 10Web Manager</a><br/>Plugin<img src="assets/images/icons/right-arrow.png" alt=""/>Install&Activate</h1>
            </div>
          </div>
          <a class="db-link-desc"><span>Why do I need to install 10Web Manager plugin?</span>
            <div class="manager-desc" id="manager-span">
              <p>{{'text_addWebsiteDialogAutoAnswer3' | dbText}}</p>
            </div>
          </a>
        </div>
      </div>
      <div class="db-inactive-website-troubleshoot-footer" [innerHTML]="'text_inactiveWebsiteStillDisconnected' | dbText"></div>
    </div>
  </div>
</db-dialog-wrapper>
